/** Cod HTML ANPC SAL + SOL — imagini locale (250×50), mereu funcționale. */
export const DEFAULT_ANPC_HTML = `<div class="anpc-banners-footer">
<a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" title="Soluționarea Alternativă a Litigiilor">
<img src="/legal-anpc-sal.png" alt="Sigla SAL - ANPC" width="250" height="50">
</a>
<a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" title="Soluționarea Online a Litigiilor">
<img src="/legal-anpc-sol.png" alt="Sigla SOL - Comisia Europeană" width="250" height="50">
</a>
</div>`;

export function anpcHtmlLooksInvalid(html) {
    if (!html?.trim()) return false;
    return /URL-CATRE|placeholder|example\.com/i.test(html);
}

/** Înlocuiește URL-uri placeholder / externe problematice cu imagini locale. */
export function fixAnpcHtml(html) {
    if (!html?.trim()) return html;
    return html
        .replace(/URL-CATRE-BANNERUL-SAL\.png/gi, '/legal-anpc-sal.png')
        .replace(/URL-CATRE-BANNERUL-SOL\.png/gi, '/legal-anpc-sol.png')
        .replace(/https:\/\/etamade-com\.github\.io\/anpc-sal-sol-logo\/anpc-sal\.svg/gi, '/legal-anpc-sal.png')
        .replace(/https:\/\/etamade-com\.github\.io\/anpc-sal-sol-logo\/anpc-sol\.svg/gi, '/legal-anpc-sol.png');
}

export function getAnpcPublicBase() {
    return process.env.PUBLIC_URL || '';
}
